import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiqInputComponent } from './components/datiq-input/datiq-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
    DatiqValidatorsRegisterService,
    DatiqInputErrorTypes,
    DatiqInputValidatorRequiredService,
} from '@dat/datiq-components-pkg/utils';

import {
    DatiqInputValidatorMaxlengthService,
    DatiqInputValidatorMaxService,
    DatiqInputValidatorMinlengthService,
    DatiqInputValidatorMinService,
    DatiqInputValidatorPatternService,
    DatiqInputValidatorPercentmaxService,
    DatiqInputValidatorPercentminService,
} from './components/datiq-input/services';
import { DatiqCheckboxModule } from '@dat/datiq-components-pkg/checkbox';
import { DatiqDatepickerModule } from '@dat/datiq-components-pkg/datepicker';
import { DatiqChecklistModule } from '@dat/datiq-components-pkg/checklist';
import { DatiqSelectModule } from '@dat/datiq-components-pkg/select';
import { DatiqToggleButtonModule } from '@dat/datiq-components-pkg/toggle-button';
import { DigitOnlyDirective } from './directives';
import { DatiqSliderModule } from '@dat/datiq-components-pkg/slider';
import { DatiqFormComponent } from './components/datiq-form/datiq-form.component';
import { DatiqButtonModule } from '@dat/datiq-components-pkg/button';
import { DatiqInputTextModule } from '@dat/datiq-components-pkg/input-text';
import { NgxCurrencyDirective } from 'ngx-currency';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { DatiqTimelineInputComponent } from '@dat/datiq-components-pkg/timeline';
@NgModule({
    declarations: [DatiqInputComponent, DigitOnlyDirective, DatiqFormComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatFormFieldModule,
        MatInputModule,
        NgxCurrencyDirective,
        NgxMaskDirective,
        DatiqCheckboxModule,
        DatiqDatepickerModule,
        DatiqSelectModule,
        DatiqButtonModule,
        DatiqTimelineInputComponent,
        DatiqChecklistModule,
        DatiqSliderModule,
        DatiqInputTextModule,
        DatiqToggleButtonModule,
    ],
    providers: [
        provideNgxMask(),
    ],
    exports: [DatiqInputComponent, DigitOnlyDirective, DatiqFormComponent],
})
export class DatiqInputModule {
    constructor(
        private _validatorRegistry: DatiqValidatorsRegisterService,
        private _max: DatiqInputValidatorMaxService,
        private _maxlength: DatiqInputValidatorMaxlengthService,
        private _min: DatiqInputValidatorMinService,
        private _minlength: DatiqInputValidatorMinlengthService,
        private _pattern: DatiqInputValidatorPatternService,
        private _percentmax: DatiqInputValidatorPercentmaxService,
        private _percentmin: DatiqInputValidatorPercentminService,
        private _required: DatiqInputValidatorRequiredService
    ) {
        this._validatorRegistry.register(DatiqInputErrorTypes.Max, this._max);

        this._validatorRegistry.register(
            DatiqInputErrorTypes.MaxLength,
            this._maxlength
        );

        this._validatorRegistry.register(DatiqInputErrorTypes.Min, this._min);

        this._validatorRegistry.register(
            DatiqInputErrorTypes.MinLength,
            this._minlength
        );

        this._validatorRegistry.register(
            DatiqInputErrorTypes.Pattern,
            this._pattern
        );

        this._validatorRegistry.register(
            DatiqInputErrorTypes.PercentMax,
            this._percentmax
        );

        this._validatorRegistry.register(
            DatiqInputErrorTypes.PercentMin,
            this._percentmin
        );

        this._validatorRegistry.register(
            DatiqInputErrorTypes.Required,
            this._required
        );
    }
}
